import React, { useCallback, useState } from 'react'
import API from '../../../../services/api'
import IconButton from '../../../molecules/iconbutton/IconButton'
import SimpleModal from '../../../organisms/standard-modal/SimpleModal'
import ReportingPagePreviewTile from '../components/ReportingPagePreviewTile'
import { data as fakePreviewData } from '../../results/data/fakePreviewData'
import Clickable from '../../../atoms/clickable/Clickable'
import InlineGroup from '../../../atoms/inlinegroup/InlineGroup'
import VerticalGroup from '../../../atoms/verticalgroup/VerticalGroup'
import Text from '../../../atoms/text/Text'

interface Props {
  template: API.ReportingTemplateResponse
  onFinish: () => void
}

const FAKE_TEXT_LAYOUT: API.ReportingTemplateLayoutResponse = {
  id: 'text_layout',
  type: 'custom_text',
  config: {
    type: 'custom_text',
    heading: 'Custom Heading',
    body: 'Insert Text Here'
  },
  sort: 0,
  enabled: true,
  roundRestrictions: []
}

const FAKE_IMAGE_LAYOUT: API.ReportingTemplateLayoutResponse = {
  id: 'image_layout',
  type: 'custom_image',
  config: {
    type: 'custom_image',
    heading: 'Custom Heading',
    imageUrl: 'https://via.placeholder.com/728x500.png?text=Add+Your+Custom+Image'
  },
  sort: 0,
  enabled: true,
  roundRestrictions: []
}

export const AddReportingTemplateLayout: React.FC<Props> = ({ template, onFinish }) => {
  const [, setError] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const onClick = useCallback((type: 'custom_text' | 'custom_image' ) => async (event: any) => {
    event.stopPropagation()
    try {
      let payload = {...FAKE_TEXT_LAYOUT}
      if (type === 'custom_image') {
        payload = {...FAKE_IMAGE_LAYOUT}
        delete payload.config.imageUrl
      }
      delete payload.id
      // @ts-expect-error
      await API.createReportingTemplateLayout(template.id, payload)
      onFinish()
      setShowModal(false)
    } catch (e) {
      setError(true)
    }
  }, [template.id, onFinish])

  return (<>
    <IconButton
      data-test={`add-layout-${template.id}`}
      icon='copy'
      text='Add Layout'
      onClick={() => { setShowModal(true) }}
    />
    <SimpleModal
      size='medium'
      isOpen={showModal}
      showCloseButton
      onClose={() => setShowModal(false)}
    >
      <h2>Choose Layout</h2>
      <InlineGroup spaceLeft={2}>
        <Clickable onClick={onClick('custom_text')}>
          <VerticalGroup center spaceBetweenElements={2}>
            <Text bold>Custom Text</Text>
            <ReportingPagePreviewTile
              data={{
                ...fakePreviewData,
                layouts: [FAKE_TEXT_LAYOUT]
              }}
              layout={FAKE_TEXT_LAYOUT}
              showHeader
            />
          </VerticalGroup>
        </Clickable>
        <Clickable onClick={onClick('custom_image')}>
          <VerticalGroup center spaceBetweenElements={2}>
            <Text bold>Custom Image</Text>
            <ReportingPagePreviewTile
              data={{
                ...fakePreviewData,
                layouts: [FAKE_IMAGE_LAYOUT]
              }}
              layout={FAKE_IMAGE_LAYOUT}
              showHeader
            />
          </VerticalGroup>
        </Clickable>
      </InlineGroup>
    </SimpleModal>
  </>)
}


